<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <app-loading [condition]="isLoading.client"></app-loading>
    @if (!isLoading.client) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Client <app-breadcrumb [menuItems]="menuItems" [currentContent]="currentContent"></app-breadcrumb>
        </h4>
        <div class="card-body pb-0">
          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col mb-3 pr-lg-1">
              <app-client [client]="client"></app-client>
            </div>
            <div class="col mb-3">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">
                    Status
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-details-modal" (click)="toggleEditClientDetailsModal('active')">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                  </h5>
                  <div>
                    <i class="fa fa-circle me-1" [ngClass]="{ 'text-success': client.active, 'text-danger': !client.active }"></i>
                    {{client.active ? 'Active' : 'Inactive'}}
                    @if (!client.active && client.inactiveDate) {
                      <small class="text-muted">(since {{client.inactiveDate | date}})</small>
                    }
                  </div>
                  <h5 class="card-title mt-3">
                    Google Drive folder
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-details-modal" (click)="toggleEditClientDetailsModal('driveurl')">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                  </h5>
                  @if (client.driveurl) {
                    <div>
                      <i class="fa fa-folder me-1"></i> <a [href]="client.driveurl" target="_blank">Google Drive folder</a>
                    </div>
                  }
                  @if (!client.driveurl && client.active) {
                    <div class="text-danger">
                      No Google Drive folder found, please add one.
                    </div>
                  }
                  @if (!client.driveurl && !client.active) {
                    <div>
                      Nothing found.
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col mb-3 pr-lg-1">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">
                    Notes
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-details-modal" (click)="toggleEditClientDetailsModal('notes')">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                  </h5>
                  @if (client.notes) {
                    <div>
                      <p [innerHTML]="formatNotes(client.notes)"></p>
                    </div>
                  }
                  @if (!client.notes) {
                    <div>
                      Nothing found.
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="col mb-3">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">
                    Socials
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-details-modal" (click)="toggleEditClientDetailsModal('socials')">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                  </h5>
                  <div>
                    <app-socials [item]="client" side="left" text="yes"></app-socials>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="card border-0" [hidden]="currentContent !== 'track-record'">
      <h4 class="card-header border-0">
        Track record
      </h4>
      <div class="card-body">
        @if (isLoading.summary) {
          <p>
            <app-spinner [condition]="isLoading.summary"></app-spinner>
          </p>
        }
        @if (false && !isLoading.summary && summary) {
          <div class="card mb-3">
            <div class="card-body">
              <i class="fa fa-magic fa-fw me-1"></i>Records summary by AI ({{currentReviewYear}}):<br>
              {{summary}}
            </div>
          </div>
        }
        @if (!isLoading.records && records?.length) {
          <p>
            <span class="badge badge-primary">{{count}}</span> results found:
          </p>
        }
        @if (isLoading.records === false && records?.length === 0) {
          <p>
            Nothing found.
          </p>
        }
        @if (isLoading.records) {
          <p>
            <app-spinner [condition]="isLoading.records"></app-spinner>
          </p>
        }
        @if (records?.length) {
          <div class="row row-cols-1 row-cols-lg-2" [ngClass]="{ 'disabled': isLoading.records }">
            @for (record of records; track record) {
              <div class="col mb-3">
                <app-record [record]="record" [clients]="clients"></app-record>
              </div>
            }
          </div>
        }
        @if (records?.length) {
          <div>
            <app-pagination [isLoading]="isLoading.records" [count]="count" [perPage]="perPage" [page]="page" eventName="getRecords"></app-pagination>
            <app-spinner [condition]="isLoading.records"></app-spinner>
          </div>
        }
      </div>
    </div>
    <div class="card border-0" [hidden]="currentContent !== 'contracts'">
      <h4 class="card-header border-0">
        Contracts
      </h4>
      @if (!isLoading.client) {
        <div class="card-body">
          <div class="row row-cols-1 row-cols-lg-1">
            <div class="col mb-3 pr-lg-1">
              <div class="card h-100 border border-primary cursor-pointer" data-bs-toggle="modal" data-bs-target="#add-contract-modal" (click)="toggleEditArrayFieldModal('contract')">
                <div class="card-body">
                  <h5 class="card-title">
                    <div class="d-flex align-items-center justify-content-center mh-100">
                      <div class="text-primary">
                        <i class="fa fa-plus-circle me-1"></i>
                        Add new contract
                      </div>
                    </div>
                  </h5>
                </div>
              </div>
            </div>
            @for (contract of client.contracts; track contract) {
              <div class="col mb-3 pr-lg-1">
                <div class="card h-100">
                  <div class="card-body">
                    <h5 class="card-title">
                      {{contract.name}}
                      <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-details-modal" (click)="toggleEditClientDetailsModal('contract', contract)">
                        <i class="fa fa-pencil"></i> Edit
                      </button>
                      <app-delete-btn size="xs" (click)="deleteArrayField(contract.id, 'contract')"></app-delete-btn>
                    </h5>
                    <div class="d-flex flex-column">
                      <div class="mt-1">
                        <i class="fa fa-calendar-check-o text-success"></i> Start date: {{!contract.startDate ? '?' : (contract.startDate | date)}}
                      </div>
                      <div class="mt-1">
                        <i class="fa fa-calendar-times-o text-danger"></i> End date: {{contract.endDate | date}} <span class="text-muted">{{isPastDate(contract.endDate) ? '(expired)' : ''}}</span>
                      </div>
                      <!-- <div class="mt-1" *ngIf="contract.money">
                      <i class="fa fa-money"></i> Money value: &euro;{{contract.money | number}}
                    </div> -->
                    @if (contract.cancellationDays) {
                      <div class="mt-1">
                        <i class="fa fa-times"></i> Cancellation date: {{(contract.cancellationDate | date) || 'N/D' }} ({{contract.cancellationDays}} days)
                      </div>
                    }
                    @if (contract.autorenewal) {
                      <div class="mt-1">
                        <i class="fa fa-refresh"></i> Autorenewal
                      </div>
                    }
                  </div>
                  <div class="d-flex flex-row justify-content-end text-muted">
                    @if (contract.created_at) {
                      <small>
                        added on {{contract.created_at | date}}
                        @if (contract.updated_at) {
                          <i class="fa fa-clock-o cursor-pointer" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="updated on {{contract.updated_at | date}}"></i>
                        }
                      </small>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="card border-0" [hidden]="currentContent !== 'goals'">
    <h4 class="card-header border-0">
      Goals
    </h4>
    @if (!isLoading.client) {
      <div class="card-body">
        <div class="row row-cols-1 row-cols-lg-1">
          <div class="col mb-3 pr-lg-1">
            <div class="card h-100 border border-primary cursor-pointer" data-bs-toggle="modal" data-bs-target="#add-goal-modal" (click)="toggleEditArrayFieldModal('goal')">
              <div class="card-body">
                <h5 class="card-title">
                  <div class="d-flex align-items-center justify-content-center mh-100">
                    <div class="text-primary">
                      <i class="fa fa-plus-circle me-1"></i>
                      Add new goal
                    </div>
                  </div>
                </h5>
              </div>
            </div>
          </div>
          @for (goal of client.goals; track goal) {
            <div class="col mb-3 pr-lg-1">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">
                    {{goal.description}}
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-details-modal" (click)="toggleEditClientDetailsModal('goal', goal)">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                    <app-delete-btn size="xs" (click)="deleteArrayField(goal.id, 'goal')"></app-delete-btn>
                  </h5>
                  <div class="d-flex flex-column">
                    <div class="mt-1">
                      <i class="fa fa-circle" [ngClass]="{ 'text-success': goal.achieved, 'text-danger': !goal.achieved }"></i> Status:
                      {{goal.achieved ? 'achieved!' : 'not achieved yet'}}
                      @if (goal.achieved) {
                        <span class="emoji-tada"></span>
                      }
                    </div>
                    <div class="mt-1">
                      <i class="fa fa-calendar"></i> Due date: {{!goal.dueDate ? 'None' : (goal.dueDate | date)}} <span class="text-muted">{{(isPastDate(goal.dueDate) && !goal.achieved) ? '(expired)' : ''}}</span>
                    </div>
                  </div>
                  <div class="d-flex flex-row justify-content-end text-muted">
                    @if (goal.created_at) {
                      <small>
                        added on {{goal.created_at | date}}
                        @if (goal.updated_at) {
                          <i class="fa fa-clock-o cursor-pointer" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="updated on {{goal.updated_at | date}}"></i>
                        }
                      </small>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="card border-0" [hidden]="currentContent !== 'reviews'">
    <h4 class="card-header border-0">
      Yearly reviews
    </h4>
    @if (!isLoading.client) {
      <div class="card-body">
        <h4 class="card-header border-bottom-0">
          <div class="btn-group me-2">
            @for (reviewYear of reviewYears; track reviewYear) {
              <button class="btn" type="button"
                [ngClass]="{ 'btn-primary': currentReviewYear === reviewYear, 'btn-outline-primary': currentReviewYear !== reviewYear }"
                (click)="selectReviewYear(reviewYear)">
                {{reviewYear}}
              </button>
            }
          </div>
          <button class="btn btn-sm btn-primary py-0 px-1 ms-2 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-details-modal" (click)="toggleEditClientDetailsModal('reviews')">
            <i class="fa fa-pencil"></i> Edit {{currentReviewYear}}
          </button>
        </h4>
        <div class="row row-cols-1 row-cols-lg-3">
          <div class="col mb-3 pr-lg-1">
            <div class="card h-100 border-top-0">
              <div class="card-body">
                <h5 class="card-title">
                  <i class="fa fa-thumbs-up text-success"></i> Good
                </h5>
                @if (client.reviews?.['good_'+currentReviewYear]) {
                  <div>
                    <p [innerHTML]="formatNotes(client.reviews['good_'+currentReviewYear])"></p>
                  </div>
                }
                @if (!client.reviews?.['good_'+currentReviewYear]) {
                  <div>
                    Nothing found.
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col mb-3 pr-lg-1">
            <div class="card h-100 border-top-0">
              <div class="card-body">
                <h5 class="card-title">
                  <i class="fa fa-thumbs-down text-danger"></i> Bad
                </h5>
                @if (client.reviews?.['bad_'+currentReviewYear]) {
                  <div>
                    <p [innerHTML]="formatNotes(client.reviews['bad_'+currentReviewYear])"></p>
                  </div>
                }
                @if (!client.reviews?.['bad_'+currentReviewYear]) {
                  <div>
                    Nothing found.
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col mb-3">
            <div class="card h-100 border-top-0">
              <div class="card-body">
                <h5 class="card-title">
                  <i class="fa fa-comments"></i> Discussion
                </h5>
                @if (client.reviews?.['discussion_'+currentReviewYear]) {
                  <div>
                    <p [innerHTML]="formatNotes(client.reviews['discussion_'+currentReviewYear])"></p>
                  </div>
                }
                @if (!client.reviews?.['discussion_'+currentReviewYear]) {
                  <div>
                    Nothing found.
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="card-header">
          <h4>Guidelines</h4>
          <ul>
            <li>Valutazione dello stato di avanzamento delle attività per il cliente: quali obiettivi fra quelli individuati nei piani strategici sono stati raggiunti?  Quali obiettivi sono ancora da raggiungere? In quanto tempo è stato raggiunto l'obiettivo?</li>
            <li>Quali attività residue devono ancora essere eseguite (es. tavole rotonde/conferenze stampa/talk non organizzati ma inseriti nei piani)</li>
            <li>Chi è il responsabile delle singole attività che devono ancora essere portate avanti? Fissare le responsabilità e gli owner dei singoli progetti e una timeline di esecuzione.</li>
            <li>Cosa abbiamo imparato in questi mesi dalla gestione di questo cliente? Cosa abbiamo imparato in generale da questo cliente?</li>
            <li>Quale know how abbiamo sviluppato? Abbiamo creato una best practice? Abbiamo imparato qualcosa da NON fare?</li>
            <li>Qual è la cosa fatta meglio? Quale la cosa fatta peggio?</li>
            <li>Che errori abbiamo commesso?</li>
            <li>Ci sono stati problemi/malintesi fra i componenti il team?</li>
            <li>Qual è il prossimo obiettivo che ci diamo come team? </li>
            <li>Siamo riusciti a creare la necessaria interazione PA/Media/Digital/The Watcher/Studios?</li>
            <li>Possiamo/E' utile integrare la classica attività di comunicazione con un'attività Digital? </li>
            <li>Possiamo/E' necessario fare upselling con i servizi di Bruxelles?</li>
            <li>Quali ulteriori servizi è possibile vendere? </li>
            <li>È possibile vendere dei format degli UTOPIA Studios - URANIA?</li>
            <li>È possibile vendere i nuovi servizi di The Watcher Post?</li>
            <li>È utile per il raggiungimento dell'obiettivo utilizzare The Watcher Post come terza parte?</li>
            <li>Qual è stato il valore aggiunto della nostra consulenza percepito dal cliente? </li>
            <li>Il cliente è soddisfatto? </li>
            <li>Ci sono dei problemi con il cliente? Quali? (Evitare di far diventare questa la discussione preponderante della riunione e svolgere l'analisi con oggettività).</li>
            <li>Verificare scadenze contrattuali, rinnovi, mancati pagamenti, eventuali upselling e nuovi servizi da erogare (es nuovi servizi digital; servizi erogati dal team di Bruxelles).</li>
          </ul>
        </div>
      </div>
    }
  </div>
</div>
</div>

@if (isAddModalVisible.contract) {
  <app-add-contract-modal [client]="client"></app-add-contract-modal>
}
@if (isAddModalVisible.goal) {
  <app-add-goal-modal [client]="client"></app-add-goal-modal>
}
<app-edit-client-details-modal [hidden]="!isEditClientDetailsModalVisible" [field]="field" [reviewYear]="currentReviewYear" [client]="client"></app-edit-client-details-modal>